module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/fineFragrance@2x_630974.png";